(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instagram-shop"] && !Shopify.designMode) return;
  try {
    
// Fancybox Lazy Load - loads CSS + JS only when user clicks instagram-shop item
(function() {
  'use strict';
  
  let fancyboxLoaded = false;
  let fancyboxLoading = false;
  
  function loadFancybox(triggerElement) {
    if (fancyboxLoaded || fancyboxLoading) return;
    
    fancyboxLoading = true;
    
    // Load CSS first
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.css';
    document.head.appendChild(link);
    
    // Then load JS
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.umd.js';
    
    script.onload = function() {
      fancyboxLoaded = true;
      fancyboxLoading = false;
      
      // Re-trigger click after library loads
      setTimeout(function() {
        triggerElement.click();
      }, 50);
    };
    
    script.onerror = function() {
      console.error('[Instagram Shop] Failed to load Fancybox');
      fancyboxLoading = false;
    };
    
    document.head.appendChild(script);
  }
  
  // Listen for clicks on Fancybox triggers (capture phase for early interception)
  document.addEventListener('click', function(e) {
    const fancyboxTrigger = e.target.closest('[data-fancybox]');
    
    if (fancyboxTrigger && !fancyboxLoaded && !fancyboxLoading) {
      e.preventDefault();
      e.stopPropagation();
      loadFancybox(fancyboxTrigger);
    }
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
    
// Fancybox Lazy Load - loads CSS + JS only when user clicks lookbook item
(function() {
  'use strict';
  
  let fancyboxLoaded = false;
  let fancyboxLoading = false;
  
  function loadFancybox(triggerElement) {
    if (fancyboxLoaded || fancyboxLoading) return;
    
    fancyboxLoading = true;
    
    // Load CSS first
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.css';
    document.head.appendChild(link);
    
    // Then load JS
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.umd.js';
    
    script.onload = function() {
      fancyboxLoaded = true;
      fancyboxLoading = false;
      
      // Re-trigger click after library loads
      setTimeout(function() {
        triggerElement.click();
      }, 50);
    };
    
    script.onerror = function() {
      console.error('[Lookbook] Failed to load Fancybox');
      fancyboxLoading = false;
    };
    
    document.head.appendChild(script);
  }
  
  // Listen for clicks on Fancybox triggers (capture phase for early interception)
  document.addEventListener('click', function(e) {
    const fancyboxTrigger = e.target.closest('[data-fancybox]');
    
    if (fancyboxTrigger && !fancyboxLoaded && !fancyboxLoading) {
      e.preventDefault();
      e.stopPropagation();
      loadFancybox(fancyboxTrigger);
    }
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-layout-2"]) return;
  try {
    
// Fancybox Lazy Load - loads CSS + JS only when user clicks to zoom
(function() {
  'use strict';
  
  let fancyboxLoaded = false;
  let fancyboxLoading = false;
  
  function loadFancybox(triggerElement) {
    if (fancyboxLoaded || fancyboxLoading) return;
    
    fancyboxLoading = true;
    
    // Load CSS first
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.css';
    document.head.appendChild(link);
    
    // Then load JS
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.umd.js';
    
    script.onload = function() {
      fancyboxLoaded = true;
      fancyboxLoading = false;
      
      // Re-trigger click after library loads
      setTimeout(function() {
        triggerElement.click();
      }, 50);
    };
    
    script.onerror = function() {
      console.error('[Product Layout 2] Failed to load Fancybox');
      fancyboxLoading = false;
    };
    
    document.head.appendChild(script);
  }
  
  // Listen for clicks on Fancybox triggers (capture phase for early interception)
  document.addEventListener('click', function(e) {
    const fancyboxTrigger = e.target.closest('[data-fancybox]');
    
    if (fancyboxTrigger && !fancyboxLoaded && !fancyboxLoading) {
      e.preventDefault();
      e.stopPropagation();
      loadFancybox(fancyboxTrigger);
    }
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
// Fancybox Lazy Load - loads CSS + JS only when user clicks to zoom
(function() {
  'use strict';
  
  let fancyboxLoaded = false;
  let fancyboxLoading = false;
  
  function loadFancybox(triggerElement) {
    if (fancyboxLoaded || fancyboxLoading) return;
    
    fancyboxLoading = true;
    
    // Load CSS first
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.css';
    document.head.appendChild(link);
    
    // Then load JS
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.umd.js';
    
    script.onload = function() {
      fancyboxLoaded = true;
      fancyboxLoading = false;
      
      // Re-trigger click after library loads
      setTimeout(function() {
        triggerElement.click();
      }, 50);
    };
    
    script.onerror = function() {
      console.error('[Product] Failed to load Fancybox');
      fancyboxLoading = false;
    };
    
    document.head.appendChild(script);
  }
  
  // Listen for clicks on Fancybox triggers (capture phase for early interception)
  document.addEventListener('click', function(e) {
    const fancyboxTrigger = e.target.closest('[data-fancybox]');
    
    if (fancyboxTrigger && !fancyboxLoaded && !fancyboxLoading) {
      e.preventDefault();
      e.stopPropagation();
      loadFancybox(fancyboxTrigger);
    }
  }, true);
})();

  } catch(e) { console.error(e); }
})();
})();
